export const PARTY_THEMES = {
  classic: {
    name: "Classic",
    emoji: "🎉",
    gradient: "from-primary to-secondary",
    accent: "hsl(var(--primary))",
    bgClass: "bg-background",
    cardClass: "bg-card",
    buttonClass: "bg-primary text-primary-foreground hover:bg-primary/90",
    accentButtonClass: "bg-secondary text-secondary-foreground hover:bg-secondary/90",
    textClass: "text-foreground",
    mutedTextClass: "text-muted-foreground",
    borderClass: "border-border",
    decorations: ["🎈", "🎊", "🎁", "🎉", "✨"],
    balloonColors: [
      "hsl(var(--primary))",
      "hsl(var(--secondary))",
      "hsl(var(--accent))",
      "#f5c542",
      "#a78bfa",
      "#60a5fa",
    ],
  },
  princess: {
    name: "Princess",
    emoji: "👑",
    gradient: "from-pink-400 to-purple-400",
    accent: "#ec4899",
    bgClass: "bg-gradient-to-b from-pink-50 to-purple-50 dark:from-pink-950 dark:to-purple-950",
    cardClass: "bg-white/90 dark:bg-pink-900/30 border border-pink-200 dark:border-pink-800",
    buttonClass: "bg-pink-500 text-white hover:bg-pink-600",
    accentButtonClass: "bg-purple-500 text-white hover:bg-purple-600",
    textClass: "text-pink-900 dark:text-pink-100",
    mutedTextClass: "text-pink-600 dark:text-pink-300",
    borderClass: "border-pink-200 dark:border-pink-700",
    decorations: ["👑", "💎", "🌸", "💕", "✨", "🏰"],
    balloonColors: ["#ec4899", "#f472b6", "#c084fc", "#e879f9", "#fda4af"],
  },
  superhero: {
    name: "Superhero",
    emoji: "🦸",
    gradient: "from-red-500 to-blue-500",
    accent: "#ef4444",
    bgClass: "bg-gradient-to-br from-blue-900 via-indigo-900 to-red-900",
    cardClass: "bg-slate-800/90 border border-blue-500/30",
    buttonClass: "bg-red-600 text-white hover:bg-red-700",
    accentButtonClass: "bg-blue-600 text-white hover:bg-blue-700",
    textClass: "text-white",
    mutedTextClass: "text-blue-200",
    borderClass: "border-blue-500/30",
    decorations: ["💥", "⚡", "🦸", "⭐", "🔥", "💪"],
    balloonColors: ["#ef4444", "#3b82f6", "#fbbf24", "#dc2626", "#2563eb"],
  },
  dinosaur: {
    name: "Dinosaur",
    emoji: "🦕",
    gradient: "from-green-500 to-emerald-600",
    accent: "#22c55e",
    bgClass: "bg-gradient-to-b from-green-50 to-emerald-100 dark:from-green-950 dark:to-emerald-950",
    cardClass: "bg-white/90 dark:bg-green-900/30 border border-green-300 dark:border-green-700",
    buttonClass: "bg-green-600 text-white hover:bg-green-700",
    accentButtonClass: "bg-emerald-600 text-white hover:bg-emerald-700",
    textClass: "text-green-900 dark:text-green-100",
    mutedTextClass: "text-green-600 dark:text-green-300",
    borderClass: "border-green-300 dark:border-green-700",
    decorations: ["🦕", "🦖", "🌿", "🌋", "🥚", "🍃"],
    balloonColors: ["#22c55e", "#10b981", "#84cc16", "#4ade80", "#16a34a"],
  },
  unicorn: {
    name: "Unicorn",
    emoji: "🦄",
    gradient: "from-purple-400 via-pink-400 to-yellow-300",
    accent: "#a855f7",
    bgClass: "bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100 dark:from-purple-950 dark:via-pink-950 dark:to-indigo-950",
    cardClass: "bg-white/80 dark:bg-purple-900/30 border border-purple-200 dark:border-purple-700",
    buttonClass: "bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600",
    accentButtonClass: "bg-gradient-to-r from-pink-400 to-yellow-400 text-purple-900 hover:from-pink-500 hover:to-yellow-500",
    textClass: "text-purple-900 dark:text-purple-100",
    mutedTextClass: "text-purple-600 dark:text-purple-300",
    borderClass: "border-purple-200 dark:border-purple-700",
    decorations: ["🦄", "🌈", "✨", "⭐", "💫", "🌟"],
    balloonColors: ["#a855f7", "#ec4899", "#fde047", "#c084fc", "#f472b6"],
  },
  space: {
    name: "Space",
    emoji: "🚀",
    gradient: "from-indigo-600 to-purple-900",
    accent: "#6366f1",
    bgClass: "bg-gradient-to-b from-indigo-950 via-purple-950 to-slate-950",
    cardClass: "bg-indigo-900/50 border border-indigo-500/30",
    buttonClass: "bg-indigo-600 text-white hover:bg-indigo-700",
    accentButtonClass: "bg-purple-600 text-white hover:bg-purple-700",
    textClass: "text-white",
    mutedTextClass: "text-indigo-300",
    borderClass: "border-indigo-500/30",
    decorations: ["🚀", "🌟", "🪐", "👽", "⭐", "🛸"],
    balloonColors: ["#6366f1", "#8b5cf6", "#a78bfa", "#312e81", "#4f46e5"],
  },
  ocean: {
    name: "Ocean",
    emoji: "🐠",
    gradient: "from-cyan-400 to-blue-500",
    accent: "#06b6d4",
    bgClass: "bg-gradient-to-b from-cyan-100 via-blue-100 to-blue-200 dark:from-cyan-950 dark:via-blue-950 dark:to-slate-950",
    cardClass: "bg-white/90 dark:bg-cyan-900/30 border border-cyan-300 dark:border-cyan-700",
    buttonClass: "bg-cyan-600 text-white hover:bg-cyan-700",
    accentButtonClass: "bg-blue-600 text-white hover:bg-blue-700",
    textClass: "text-cyan-900 dark:text-cyan-100",
    mutedTextClass: "text-cyan-600 dark:text-cyan-300",
    borderClass: "border-cyan-300 dark:border-cyan-700",
    decorations: ["🐠", "🫧", "🐙", "🦀", "🐚", "🐟"],
    balloonColors: ["#06b6d4", "#0ea5e9", "#22d3ee", "#38bdf8", "#0284c7"],
  },
  safari: {
    name: "Safari",
    emoji: "🦁",
    gradient: "from-amber-400 to-orange-500",
    accent: "#f59e0b",
    bgClass: "bg-gradient-to-b from-amber-50 via-orange-50 to-yellow-100 dark:from-amber-950 dark:via-orange-950 dark:to-yellow-950",
    cardClass: "bg-white/90 dark:bg-amber-900/30 border border-amber-300 dark:border-amber-700",
    buttonClass: "bg-orange-600 text-white hover:bg-orange-700",
    accentButtonClass: "bg-amber-600 text-white hover:bg-amber-700",
    textClass: "text-amber-900 dark:text-amber-100",
    mutedTextClass: "text-amber-600 dark:text-amber-300",
    borderClass: "border-amber-300 dark:border-amber-700",
    decorations: ["🦁", "🐘", "🦒", "🌴", "🌿", "🌻"],
    balloonColors: ["#f59e0b", "#fb923c", "#fbbf24", "#ea580c", "#d97706"],
  },
} as const;

export type ThemeKey = keyof typeof PARTY_THEMES;
export type ThemeConfig = (typeof PARTY_THEMES)[ThemeKey];

export const getThemeConfig = (theme: string | null | undefined): ThemeConfig => {
  return PARTY_THEMES[(theme as ThemeKey) || "classic"] || PARTY_THEMES.classic;
};

// Mapping from invite template ID to party theme
export const TEMPLATE_TO_THEME: Record<string, ThemeKey> = {
  balloons: "classic",
  princess: "princess",
  superhero: "superhero",
  dinosaur: "dinosaur",
  unicorn: "unicorn",
  space: "space",
  underwater: "ocean",
  safari: "safari",
};
